import Panzoom from '@panzoom/panzoom';

export default () => {
    const image = document.querySelector('.js-hotspot-image');
    const zoomIn = document.querySelector('.js-hotspot-zoom-in');
    const zoomOut = document.querySelector('.js-hotspot-zoom-out');
    const spots = document.querySelectorAll('.js-hotspot-point');
    const contents = document.querySelectorAll('.js-hotspot-content');
    const select = document.querySelector('.js-hotspot-select');

    // activate panzoom
    const panzoom = Panzoom(image, {
        minScale: 1,
    });

    // zoom controls
    zoomIn.addEventListener('click', panzoom.zoomIn);
    zoomOut.addEventListener('click', panzoom.zoomOut);

    /**
     * Toggle active spots on spot click or select change
     *
     * @param id
     */
    function toggleSpot(id) {
        const spot = [...spots].filter(
            (item) => item.getAttribute('data-index') === id
        )[0];
        const content = [...contents].filter(
            (item) => item.getAttribute('data-index') === id
        )[0];

        // if current spot is active, none will be active
        if (spot.classList.contains('is-active')) {
            id = '';
        } else {
            // new active spot, clear any other active spots
            clearSpots();
        }

        spot.classList.toggle('is-active');
        content.classList.toggle('is-active');

        // set the select value to the clicked spot or blank
        select.value = id;
    }

    function clearSpots() {
        const activeSpot = document.querySelector(
            '.js-hotspot-point.is-active'
        );
        const activeContent = document.querySelector(
            '.js-hotspot-content.is-active'
        );

        // if active spot/content is found, make it not active
        activeSpot && activeSpot.classList.remove('is-active');
        activeContent && activeContent.classList.remove('is-active');

        select.value = '';
    }

    // handle hotspot clicks
    spots.forEach((spot) => {
        spot.addEventListener('click', function (e) {
            toggleSpot(this.getAttribute('data-index'));
            e.stopPropagation();
        });
    });

    // handle select change
    select.addEventListener('change', function () {
        if (this.value === '') {
            clearSpots();
        } else {
            toggleSpot(this.value);
        }
    });
    // stop it from propagating
    select.addEventListener('click', (e) => {
        e.stopPropagation();
    });

    // close hotspots on body click
    document.addEventListener('click', clearSpots);
};



// WEBPACK FOOTER //
// ../src/scripts/modules/amenities.js